<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <b-card>
      <div>
        <b-card-title> Informações do Lote: </b-card-title>
        <div class="table-responsive font-size-12 m-auto mb-2">
          <b-table
            responsive="sm"
            :fields="camposCreditos"
            :items="tabelaCreditos"
            hover
          >
            <template v-slot:cell(ds_st_liberacao)="data">
              <div class="d-flex">
                <div
                  class="retangulo mr-2"
                  :class="{
                    'bg-danger': data.value === 'Pendente',
                    'bg-success': data.value === 'Liberado',
                  }"
                ></div>
                <span>{{ data.value }} </span>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <!-- LACAMENTO -->
      <div>
        <b-card-title> Lançamentos: </b-card-title>
        <div class="table-responsive font-size-12 m-auto">
          <b-table
            responsive="sm"
            :fields="camposLancamento"
            :items="tabelaLancamento"
            hover
            foot-clone
          >
            <template v-slot:cell(vl_lcto)="data">
              <span :class="data.value < 0 ? 'text-danger' : 'text-primary'">{{
                $tools.converteReal(data.value)
              }}</span>
            </template>
            <template v-slot:cell(cd_evento)="data">
              <span>{{ data.value }} - {{ data.item.ds_detalhado }}</span>
            </template>
            <template #foot()="">
              <h6></h6>
            </template>
            <template #foot(vl_lcto)="">
              <div class="text-end">
                <span class="text-dark fw-bold"
                  >TOTAL: {{ $tools.converteReal(somaLancamentos) }}
                </span>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="mb-3">
        <span>
          <strong>Opções de crédito selecionado: </strong>
          {{ tabelaCreditos[0].ds_tp_opcao }}</span
        >
      </div>
      <!-- DADOS BANCARIOS -->
      <div v-if="tabelaCreditos[0].tp_opcao != 'I'">
        <b-card-title> Dados Bancários selecionados: </b-card-title>

        <div class="table-responsive font-size-12 m-auto">
          <b-table
            responsive="sm"
            :fields="camposDadosBancarios"
            :items="tabelaDadosBancarios"
            hover
          >
          </b-table>
        </div>
      </div>

      <div class="d-flex justify-content-end px-1 mt-3">
        <div class="me-2 align-self-center mt-1">
          <router-link to="/cooperado/liberacaoCredito">
            <b-button class="btn-lg"> Voltar </b-button>
          </router-link>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import PageHeader from "@/components/page-header";

export default {
  components: {
    PageHeader,
  },
  data() {
    return {
      title: "Liberação de Créditos",
      items: [
        {
          text: "Liberação de Créditos",
          href: "/cooperado/liberacaoCredito",
          active: false,
        },
        {
          text: "Crédito Liberado",
        },
      ],
      camposCreditos: [
        {
          key: "ds_st_liberacao",
          label: "Status",
        },
        {
          key: "nr_ano",
          label: "Ano",
        },
        {
          key: "sq_libera_credito",
          label: "N°Lote",
        },
        {
          key: "vl_credito",
          label: "Créditos",
          class: "alinharCelulaDireita",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
        },
        {
          key: "vl_baixa",
          label: "Compensações",
        },
        {
          key: "vl_saldo",
          label: "Saldo",
          class: "alinharCelulaDireita",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
        },
        {
          key: "vl_liberado",
          label: "Liberado",
        },
        {
          key: "dt_autorizacao",
          label: "Autorização",
          class: "alinharCelula",
          formatter: (value) => {
            return this.$tools.converteData(value);
          },
        },
        {
          key: "dt_vencimento",
          label: "Vencimento",
          class: "alinharCelula",
          formatter: (value) => {
            return this.$tools.converteData(value);
          },
        },
        {
          key: "ds_tp_opcao",
          label: "Destino",
        },
        {
          key: "ds_st_liberacao_obs",
          label: "Observação",
        },
      ],
      tabelaCreditos: [{ ds_tp_opcao: "" }],
      camposLancamento: [
        {
          key: "sq_lcto",
          label: "Sequência",
        },
        {
          key: "cd_evento",
          label: "Tipo Documento",
        },
        {
          key: "nr_docto",
          label: "N° Documento",
        },
        {
          key: "ds_tp_natureza",
          label: "Natureza da Operação",
        },
        {
          key: "vl_lcto",
          class: "alinharCelulaDireita",
          label: "Valor",
        },
      ],
      tabelaLancamento: [],
      camposDadosBancarios: [
        {
          key: "cd_bco",
          label: "Código Banco",
        },
        {
          key: "nm_bco",
          label: "Nome Banco",
        },
        {
          key: "nr_agencia",
          label: "Nº Agência",
        },
        {
          key: "nm_agencia",
          label: "Nome Agência/Cidade	",
        },
        {
          key: "nr_cta",
          label: "Conta Bancária",
        },
        {
          key: "tp_conta",
          label: "Tipo Conta",
          formatter: (value) => {
            return value == "C" ? "Conta Corrente" : "Poupança";
          },
        },
        {
          key: "st_principal",
          label: "Principal",
          formatter: (value) => {
            return value == "S" ? "Sim" : "Não";
          },
        },
      ],
      tabelaDadosBancarios: [],
      somaLancamentos: 0,
    };
  },
  created() {
    if (this.$route.params.id) {
      this.buscarLiberacaoCredito();
      this.buscarLiberacaoCreditoCooperado();
    }
  },
  methods: {
    somaValorLancamento(item) {
      item.forEach((el) => {
        this.somaLancamentos += parseFloat(el.vl_lcto);
      });
    },
    buscarLiberacaoCredito() {
      this.$http
        .get(
          "api/contaCorrente/liberacaoCredito/buscarLiberacao/" +
            this.$route.params.id
        )
        .then((response) => {
          if (response.data) {
            this.tabelaCreditos = response.data;
            if (this.tabelaCreditos[0].tp_opcao != "P") {
              this.buscarDadosBancariosAutorizado();
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    buscarLiberacaoCreditoCooperado() {
      this.$http
        .get(
          "api/contaCorrente/liberacaoCredito/buscarCooperado/" +
            this.$route.params.id
        )
        .then((response) => {
          if (response.data) {
            this.tabelaLancamento = response.data;
            this.somaValorLancamento(this.tabelaLancamento);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    buscarDadosBancariosAutorizado() {
      this.$http
        .get(
          "api/contaCorrente/liberacaoCredito/buscarDadosBancariosAutorizado/" +
            this.$route.params.id
        )
        .then((response) => {
          if (response.data) {
            this.tabelaDadosBancarios = response.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>